import styled from 'styled-components';

import { StyledControlBarButton } from '../../control-bar-button.styles';

export const StyledAddBookmarkButton = styled(StyledControlBarButton)`
  &:hover {
    & path {
      stroke: ${({ theme }) =>
        theme.themeColors.controlBar.rightPanel.icons.bookmarkIcon
          .colorOnEmptyAndHover};
    }
  }
`;
